/**
 * Facets for product list
 */

import './_facets.twig';
import './range-slider/rSlider.min.css';
import './range-slider/_range-slider.scss';
import './_facets.scss';
import './range-slider/rSlider.min';

export const name = 'facets';

export function disable() {}

/**
 * Enables this component.
 *
 * @param {jQuery} $context - A piece of DOM
 */
(function ($, Drupal, $context) {
  const isDesktop = () => {
    return $(window).width() > 919;
  };
  // Find our component within the DOM
  const $facets = $('ul.facets', $context);
  // Bail if component does not exist
  if (!$facets.length) {
    return;
  }
  $facets.find('.facet-item .facet-item__label').click(function handler() {
    const $el = $(this);
    const $parent = $el.parent();
    $parent.toggleClass('collapsed');
    $el.attr('aria-expanded', function fn(i, attr) {
      return attr === 'true' ? 'false' : 'true';
    });
    $parent.find('.facet-group-children').slideToggle();
    // Using attr() to update DOM element and change the text
    if ($('.facet-item:not(.collapsed)').length > 0) {
      $('.facets-action').attr('data-expanded', 1);
    } else {
      $('.facets-action').attr('data-expanded', 0);
    }
  });

  let filters = $facets.data('facet-filters');
  if (filters.length) {
    filters = filters.split(';+;');
  } else {
    filters = [];
  }

  const setFilters = (
    selectedFilters,
    availableFilters,
    preSelectedFilters
  ) => {
    // Remove the previous values to avoid duplicates
    // from the filters array.
    availableFilters.forEach((value) => {
      if (filters.includes(value)) {
        const i = filters.indexOf(value);
        filters.splice(i, 1);
      }
    });

    if (
      selectedFilters.length === availableFilters.length &&
      preSelectedFilters.length === 0
    ) {
      return;
    }

    // Push selected values to filters array.
    selectedFilters.forEach((value) => {
      if (!filters.includes(value)) {
        filters.push(value);
      }
    });
  };

  const updateFilters = ($checkbox) => {
    const filter = $checkbox.data('facet-filter');
    if ($checkbox.is(':checked')) {
      if (!filters.includes(filter)) {
        filters.push(filter);
      }
    } else if (filters.includes(filter)) {
      const i = filters.indexOf(filter);
      filters.splice(i, 1);
    }
  };

  const rangeFacetSlider = () => {
    // Enable range sliders.
    const $rangeSliders = $('.range-slider', $context);
    $rangeSliders.each(function fn() {
      const $rangeSlider = $(this);
      const facetGroupId = $rangeSlider.data('facet-group');
      const $facetGroup = $(`#facet-group-${facetGroupId}`);
      const values = [];
      const availableFilters = [];
      const preSelectedFilters = [];
      const defaultValues = [];
      $facetGroup.find('.facet-item-child__checkbox').each(function fn2() {
        availableFilters.push($(this).data('facet-filter'));
        values.push(this.value);
        if (this.checked) {
          preSelectedFilters.push($(this).data('facet-filter'));
          if (!defaultValues[0]) {
            defaultValues[0] = this.value;
            defaultValues[1] = this.value;
          } else {
            defaultValues[1] = this.value;
          }
        }
      });

      if ($facetGroup.find('.facet-item-child').length < 2) {
        return;
      }

      if (!defaultValues && values.length > 1) {
        // eslint-disable-next-line prefer-destructuring
        defaultValues[0] = values[0];
        defaultValues[1] = values[values.length - 1];
      }
      // eslint-disable-next-line new-cap,no-new,no-undef
      const instance = new rSlider({
        target: $rangeSlider[0],
        values,
        set: defaultValues,
        range: true,
        tooltip: true,
        scale: true,
        labels: false,
        onChange: (selectedValues) => {
          const [start, end] = selectedValues.split(',');
          const valuesInRange = [];
          for (let i = values.indexOf(start); ; i += 1) {
            valuesInRange.push(values[i]);
            if (values[i] === end) {
              break;
            }
          }

          const selectedFilters = [];
          $facetGroup.find('.facet-item-child__checkbox').each(function fnc4() {
            this.checked = valuesInRange.includes(this.value);
            if (this.checked) {
              selectedFilters.push($(this).data('facet-filter'));
            }
          });

          setFilters(selectedFilters, availableFilters, preSelectedFilters);
        },
      });

      $facetGroup.find('.facet-item-child__checkbox').change(function fn5() {
        const isRange =
          $facetGroup.find('.facet-item-child__checkbox:checked').length !== 0;
        let indexStart = 0;
        let indexEnd = values.length - 1;
        if (isRange) {
          const [start, end] = instance.getValue().split(',');
          indexStart = values.indexOf(start);
          indexEnd = values.indexOf(end);
        }

        if (isRange) {
          const index = values.indexOf(this.value);
          if (!this.checked) {
            if (index >= indexEnd) {
              indexEnd -= 1;
            }
            if (index <= indexStart) {
              indexStart += 1;
            }
            if (indexStart < index && index < indexEnd) {
              indexEnd = index - 1;
            }
          } else {
            if (index >= indexEnd) {
              indexEnd = index;
            }
            if (index <= indexStart) {
              indexStart = index;
            }
          }
        }
        instance.setValues(values[indexStart], values[indexEnd]);
      });
    });
  };

  $facets
    .find('.facet-children .facet-item-child__checkbox')
    .on('change', function handler() {
      const $checkbox = $(this);
      if ($checkbox.hasClass('range-enabled')) {
        return;
      }
      if (isDesktop()) {
        window.location.href = $checkbox.data('facet-url');
        $facets
          .find('.facet-item-child__checkbox')
          .attr('disabled', 'disabled');
      } else {
        updateFilters($checkbox);
      }
    });

  $('#apply-filters, .range-slider-apply', $context).on(
    'click',
    function handler() {
      $facets.find('.facet-item-child__checkbox').attr('disabled', 'disabled');
      // For hoffman ignore the preselected from
      // filter sliders and recalculate again.
      if ($('body').hasClass('hoffman')) {
        filters = [];
        $facets.find('.facet-item:not(".visually-hidden")').each(function () {
          const checked = $(this).find('.facet-item-child__checkbox:checked');
          if (
            $(this).find('.facet-children').hasClass('range-enabled') &&
            $(this).find('.facet-item-child__checkbox').length ===
              checked.length
          ) {
            return true;
          }

          checked.each(function () {
            filters.push($(this).data('facet-filter'));
          });
        });
      }
      let url = '?';
      for (let i = 0; i < filters.length; i += 1) {
        if (url !== '?') {
          url += '&';
        }
        url += `f[${i}]=${filters[i]}`;
      }

      window.location.href = url;
    }
  );
  const $collapseExpand = $('.facets-action.expand-collapse', $context);
  $collapseExpand.on('click', (event) => {
    const $el = $(event.currentTarget);
    // Using attr() to read/update DOM element so css rules apply.
    let expand = !!+$el.attr('data-expanded');
    expand = !expand;
    $el.attr('data-expanded', expand ? 1 : 0);
    if (expand) {
      $facets.find('.facet-item.collapsed .facet-item__label').click();
    } else {
      $facets.find('.facet-item:not(.collapsed) .facet-item__label').click();
    }
  });

  const $clearFilters = $('.facets-action.clear-filters', $context);
  $clearFilters.click(function handler() {
    [window.location.href] = window.location.href.split('?');
  });

  const handler = (system) => {
    $facets.find(`.facet-item.${system.previous}`).addClass('visually-hidden');
    $facets
      .find(`.facet-item.${system.current}`)
      .removeClass('visually-hidden');

    if (!isDesktop()) {
      // Trigger resize event for range slider.
      window.dispatchEvent(new Event('resize'));
    }
  };
  if (Drupal.behaviors.measurementSystemToggle) {
    Drupal.behaviors.measurementSystemToggle.onChange(handler);
  } else {
    document.addEventListener('MeasurementSystemToggleReady', function fn(e) {
      e.detail.toggle.onChange(handler);
    });
  }

  const openFacets = $('#open-facets', $context);
  const closeFacets = $('#close-facets', $context);

  // Show Facets filters.
  openFacets.on('click', () => {
    openFacets
      .parent()
      .find('.facets-bar, .facets-wrapper, .facets-apply')
      .addClass('open');
    document.body.classList.toggle('js-scroll-lock');

    if (!$facets.find('.rs-container').length) {
      rangeFacetSlider();
    }
  });
  // Hide Facets filters.
  closeFacets.on('click', () => {
    closeFacets
      .parent()
      .parent()
      .find('.facets-bar, .facets-wrapper, .facets-apply')
      .removeClass('open');
    document.body.classList.toggle('js-scroll-lock');
  });

  $(window).on('resize', () => {
    if (isDesktop()) {
      $('body').removeClass('js-scroll-lock');
    } else if ($('.facets-bar--open').length > 0) {
      $('body').addClass('js-scroll-lock');
    }
  });

  // Expands and collapses items within a group.
  const viewAllToggle = $('.facet-item__toggle', $context);

  viewAllToggle.on('click', (event) => {
    const $el = $(event.currentTarget); // Ensure $el is properly initialized as a jQuery object
    const $group = $el.prev('.facet-group__collapsable');
    $el.find('.view-less').hide();
    $group.toggleClass('collapsed');
    // eslint-disable-next-line no-unused-expressions
    if ($group.hasClass('collapsed')) {
      $el.find('.view-less').hide();
      $el.find('.view-more').show();
    } else {
      $el.find('.view-less').show();
      $el.find('.view-more').hide();
    }
  });

  if (isDesktop()) {
    rangeFacetSlider();
  }

  // On click of Filter applied open Filter Modal
  const facetsClickFilter = $('.facets-pills-heading', $context);
  if (!isDesktop()) {
    facetsClickFilter.on('click', () => {
      openFacets.trigger('click');
    });
  }
})(jQuery, Drupal);
